import { Draggable, Droppable } from 'react-beautiful-dnd';
import {
  NoUngroupedQuickRepliesContainer,
  NoUngroupedQuickRepliesText,
  QuickRepliesContainer,
  QuickReply,
  QuickReplyDescription,
  QuickReplyHeader,
  QuickReplyHeaderActions,
  QuickReplyHeaderContainer,
  QuickReplyHeaderText,
  QuickReplyRow,
  UngroupedQuickRepliesContainer,
} from './UngroupedQuickReplies.styles';
import styled from 'styled-components';
import { Drag16, Reply24 } from 'ui/icons';

const NoUngroupedQuickReplies = () => {
  return (
    <NoUngroupedQuickRepliesContainer>
      <NoUngroupedQuickRepliesText>No ungrouped quick replies</NoUngroupedQuickRepliesText>
    </NoUngroupedQuickRepliesContainer>
  );
};

const StyledDraggable = styled(Draggable)`
  width: 100%;
`;

export const UngroupedQuickReplies = ({
  quickReplies,
  filteredQuickReplies,
}: { quickReplies: string[]; filteredQuickReplies: string[] }) => {
  return (
    quickReplies.length > 0 && (
      <UngroupedQuickRepliesContainer>
        <QuickReplyHeaderContainer>
          <QuickReplyHeader>
            <QuickReplyHeaderText>Ungrouped quick replies</QuickReplyHeaderText>
            <QuickReplyHeaderActions></QuickReplyHeaderActions>
          </QuickReplyHeader>
          <QuickReplyDescription>
            Drag and drop or multi-select quick replies to sort them into reply groups.
          </QuickReplyDescription>
        </QuickReplyHeaderContainer>
        {filteredQuickReplies.length === 0 ? (
          <NoUngroupedQuickReplies />
        ) : (
          <Droppable droppableId="quick-replies">
            {(provided) => (
              <QuickRepliesContainer
                ref={provided.innerRef}
                {...provided.droppableProps}
                data-test="quick-replies"
              >
                {filteredQuickReplies.map((x: string, i: number) => {
                  return (
                    <StyledDraggable key={i} draggableId={i.toString()} index={i}>
                      {(provided) => {
                        return (
                          <QuickReplyRow
                            ref={provided.innerRef}
                            {...provided.draggableProps}
                            {...provided.dragHandleProps}
                            data-test={`draggable-${i}`}
                          >
                            <Drag16 />
                            <QuickReply>
                              <Reply24 />
                              {x}
                            </QuickReply>
                          </QuickReplyRow>
                        );
                      }}
                    </StyledDraggable>
                  );
                })}
                {provided.placeholder}
              </QuickRepliesContainer>
            )}
          </Droppable>
        )}
      </UngroupedQuickRepliesContainer>
    )
  );
};
